import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { BackrsCard } from '@backrs_ui/common-ui/src/atoms/BackrsCard';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';

import { Theme, Box, SxProps, Typography } from '@mui/material';

const ICON_DIAMETER = 32;

type ActivityNuggetProps = Readonly<{
  title: string;
  hasUserCompleted: boolean;
  onClick: () => void;
}>;

export const ActivityNugget = ({ title, hasUserCompleted, onClick }: ActivityNuggetProps) => {
  return (
    <BackrsCard onClick={onClick} sx={containerStyle}>
      <Box>
        <Box sx={contentContainerStyle}>
          <Box sx={activityNuggetHeaderStyle}>
            <Box minWidth={ICON_DIAMETER} overflow="visible">
              <BackrsIcon
                name={hasUserCompleted ? 'IconChecked' : 'IconUnchecked'}
                alt={title}
                color={appColors.color.blue1}
                width={ICON_DIAMETER}
                height={ICON_DIAMETER}
              />
            </Box>
            <Typography sx={titleStyle}>{title}</Typography>
          </Box>
        </Box>
      </Box>
    </BackrsCard>
  );
};

const contentContainerStyle: SxProps<Theme> = {
  flexDirection: 'column',
  gap: 2,
  display: 'flex',
  justifyContent: 'center',
};

const activityNuggetHeaderStyle: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
};

const titleStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontWeight: 500,
  fontSize: 18,
  lineHeight: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pb: 1,
};

const containerStyle: SxProps<Theme> = {
  height: '100%',
  border: '1px solid black',
};
